import { getCountrysApi } from "@/services/common";
import { getIsOversea } from "@/utils/environmentUtils";
import useSWR from "swr";

const isOversea = getIsOversea();

const useSWRCountrys = () => {
  const { data = [] } = useSWR(
    "oam_country_enums",
    async () => {
      const res = await getCountrysApi({});
      if (res.success) {
        if (isOversea) {
          return res.model;
        }

        return res.model.filter((x) => x.componentCode === "CN100000");
      }
    },
    {
      dedupingInterval: 1000 * 60 * 30,
    },
  );

  return data;
};

export default useSWRCountrys;
